'use strict';

window.addEventListener('load', () => {
  stickyHeader();
  mobileUpdates();
});

function stickyHeader() {
  window.onscroll = function() {
    let header = document.querySelector('#shopify-section-header');
    let sticky = header.offsetTop;

    if (window.pageYOffset > sticky) {
      header.classList.add('sticky-header');
    } else {
      header.classList.remove('sticky-header');
    }
  };
}

function mobileUpdates (){
  let dropdownEnabled = false;
  let site_nav = document.querySelectorAll('.site-nav--has-dropdown');
  let nav_dropdown = document.querySelectorAll('.site-nav--has-dropdown .site-nav__dropdown a');
  const allDropdownButtons = [...document.querySelectorAll(".site-nav__link--main")];

  const resetButtons = (currentDropdownButton) => {
      allDropdownButtons.map((button) => {
        if (button.nextElementSibling && (button !== currentDropdownButton)){
          button.nextElementSibling.classList.remove("show");
        }
      })
  }
  const dropdownButtonClick = (e) => {
    let dropdownButton = e.currentTarget;
    resetButtons(dropdownButton);
    dropdownButton.nextElementSibling.classList.toggle("show");
  }
	
  const preventDropdownClick = (e) => {
      e.preventDefault();
      let i = Array.prototype.indexOf.call(site_nav, e.currentTarget.parentNode);
      let dropdown = site_nav[i].querySelectorAll('.site-nav__dropdown a');

      // remove all active links
      for (let i = 0; i < nav_dropdown.length; i++) {
        nav_dropdown[i].style.pointerEvents = "none";
      }

      setTimeout(() => {
        for (let i = 0; i < dropdown.length; i++) {
          dropdown[i].style.pointerEvents = "auto";
        }
      }, 500);
  }

  function mobileMenu() {
    if (window.innerWidth < 1024 && !dropdownEnabled) {
      for (let i = 0; i < site_nav.length; i++) {
        site_nav[i].querySelector('.site-nav__link').addEventListener('click', preventDropdownClick);
      }

      allDropdownButtons.map((button) => {
        button.addEventListener('click', dropdownButtonClick);
      })
      dropdownEnabled = true;
    } else if (window.innerWidth >= 1024 && dropdownEnabled){
      resetButtons();
      allDropdownButtons.map((button) => {
        button.removeEventListener('click', dropdownButtonClick);
      })
      for (let i = 0; i < site_nav.length; i++) {
        site_nav[i].querySelector('.site-nav__link').removeEventListener('click', preventDropdownClick);
      }
      dropdownEnabled = false;
    }
  }
  mobileMenu();
  window.onresize = mobileMenu;
}